import { render, staticRenderFns } from "./SetupStep03.vue?vue&type=template&id=53c94d38&scoped=true&"
import script from "./SetupStep03.vue?vue&type=script&lang=js&"
export * from "./SetupStep03.vue?vue&type=script&lang=js&"
import style0 from "./SetupStep03.vue?vue&type=style&index=0&id=53c94d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c94d38",
  null
  
)

export default component.exports